import * as XLSX from "xlsx";

// Get a json array from a given sheet and a tab
const getJsonFromSheet = async (url, sheetName) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const arrayBuffer = await response.arrayBuffer();

    const data = new Uint8Array(arrayBuffer);
    const workbook = XLSX.read(data, { type: "array" });

    const sheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(sheet);

    return jsonData;
  } catch (error) {
    console.error("Error fetching or parsing Excel file:", error);
  }
};

const getJsonBySeriesId = async (seriesId) => {
  const url = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${seriesId}.json`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      throw new Error(error.message);
    }
};

// Get a json object of all the tabs from a given sheet
const getAllSheetsFromFile = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const arrayBuffer = await response.arrayBuffer();

    const data = new Uint8Array(arrayBuffer);
    const workbook = XLSX.read(data, { type: "array" });

    const allSheetsData = {};

    workbook.SheetNames.forEach((sheetName) => {
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      allSheetsData[sheetName] = jsonData;
    });

    return allSheetsData;
  } catch (error) {
    console.error("Error fetching or parsing Excel file:", error);
  }
};

export { getJsonFromSheet, getJsonBySeriesId, getAllSheetsFromFile };
